import { render, staticRenderFns } from "./ComplexScreen.vue?vue&type=template&id=b0fcaa2a&scoped=true&"
import script from "./ComplexScreen.vue?vue&type=script&lang=js&"
export * from "./ComplexScreen.vue?vue&type=script&lang=js&"
import style0 from "./ComplexScreen.vue?vue&type=style&index=0&id=b0fcaa2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0fcaa2a",
  null
  
)

export default component.exports